module.exports = __webpack_public_path__ + "image/solution_banner_list.jpg";